export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/identity.js
// module id = 1403
// module chunks = 0